import './wishlist-modal.css';

export default () => {
  class WishlistModal extends HTMLElement {
    constructor() {
      super();
      this.wishlistClose = this.querySelector('#wishlist-modal-close')
      this.wishlistOpen = this.querySelector('#swym-wishlist-modal')
    }

    initEventListeners() {
      this.wishlistClose.addEventListener('click', this.closeModal.bind(this));
      this.wishlistOpen.addEventListener('click', this.openModal.bind(this));

      this.addClickOutsideListener();


      const swymButtons = document.querySelectorAll('.wishlist-layer');
      swymButtons.forEach(button => {
        button.addEventListener('click', this.closeModal.bind(this));
      });

    }

    addClickOutsideListener() {
      this.querySelector('.slide-panel__bg').addEventListener('click', () => {
        const wishlistPanel = this.querySelector('#wishlist-modal');
        if (wishlistPanel && wishlistPanel.getAttribute('default-open') === 'true') {
          this.closeModal();
        }
      });
    }

    openModal() {
      this.querySelector('#wishlist-modal').setAttribute('default-open', 'true');
      // document.body.classList.add('overflow-hidden');
      this.loadWishlist();
    }

    closeModal() {
      this.querySelector('#wishlist-modal').setAttribute('default-open', 'false');
      // document.body.classList.remove('overflow-hidden');
    }

    loadWishlist() {
      const onSuccess = (lists) => {
        const productDataDivs = document.querySelectorAll(".productData");
        if (lists.length > 0) {
          this.querySelector('#wishlist-products-count').innerHTML = `(${lists[0].listcontents.length})`;
        }

        productDataDivs.forEach((productDataDiv) => {
          // eslint-disable-next-line
          productDataDiv.innerHTML = ''
          if (lists.length > 0 && lists[0].listcontents.length > 0) {
            lists[0].listcontents.forEach((product) => {
              const productElement = this.createProductElement(product);
              productDataDiv.appendChild(productElement);
            });
          } else {
            // eslint-disable-next-line
            productDataDiv.innerHTML = '<div class="py-5 px-5 empty-cart-text"><p>Wishlist is empty</p></div>';
          }
        });
      };

      const onError = (error) => {
        // eslint-disable-next-line no-console
        console.log("Error while fetching all Lists", error);
      }


      function onSwymLoadCallback(swat) {
        swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });

        // delete from list
        setTimeout(() => {
          document.querySelectorAll('.wishlist-item-remove').forEach(item => {
            item.addEventListener('click', () => {
              // Define the list id of the list to be updated
              const lid = item.getAttribute('data-lid')

              const product = {
                epi: item.getAttribute('data-epi'),  // unique variant id  per listid
                empi: item.getAttribute('data-empi'), // product id
                du: item.getAttribute('data-du') // product url.
              };

              const onSuccessDelete = () => {
                window.location.reload()
              }

              const onErrorDelete = (error) => {
                // eslint-disable-next-line
                console.log("Error while deleting the Product", error);
              }
              swat.deleteFromList(lid, product, onSuccessDelete, onErrorDelete);
            })
          })
        }, 1000)


        if (swat) {
          // eslint-disable-next-line
          console.log("Swym scripts tags are installed on your store");
        }
      }

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(onSwymLoadCallback);

    }

    createProductElement(product) {
      const productElement = document.createElement("div");
      const formattedPrice = new Intl.NumberFormat(`en-${Shopify.country}`, {
        style: 'currency',
        currency: `${Shopify.currency.active}`
      }).format(product.pr * Shopify.currency.rate);

      productElement.innerHTML = `
        <div class="flex border-b border-light_gray w-full px-4 gap-3" data-section="cart-item">
          <div class="shrink-0">
            <a href="${product.du}">
              <picture class="w-[100px] inline-block">
                <source srcset="${product.iu}?v=1672868156&amp;width=1536 1536w" media="(min-width: 640px)">
                <img class="w-full image " src="${product.iu}" alt="" loading="lazy" width="" height="">
              </picture>
            </a>
          </div>
          <div class="py-4 grow">
            <h3 class="pdp__title font-regular text-16 leading-21px mb-8 flex justify-between items-start gap-2">
              <a href="${product.du}" class="hover:no-underline">
                <em>${product.dt}</em><br>
                <span></span>
              </a>
              <span class="body-4 shrink-0">${formattedPrice}</span>
            </h3>
            <dl role="presentation">
              <div class="product-option body-4 flex items-center">
                <dt class="uppercase">${product.vi}</dt>
                <dd class="uppercase"></dd>
              </div>
            </dl>
            <div class="cart-item__quantity-wrapper quantity-popover-wrapper flex justify-between items-center">
              <div class="quantity-selector">
                <form method="post" action="/cart/add" class="wishlist-add-to-cart">
                  <input type="hidden" name="id" value="${product.epi}" />
                  <input type="submit" value="Add To Bag" class="" />
                </form>
              </div>
              <button type="button" 
              class="button--tertiary cart-remove-button body-4  wishlist-item-remove" 
              data-lid="${product.lid}" data-epi="${product.epi}" data-empi="${product.empi}" data-du="${product.du}">
                Delete
              </button>
            </div>
          </div>
        </div>
      `;

      return productElement;
    }

    connectedCallback() {
      this.initEventListeners();
    }

    disconnectedCallback() {
      // Cleanup code if needed
    }
  }

  const init = () => {
    if (!customElements.get("wishlist-modal")) {
      customElements.define('wishlist-modal', WishlistModal);
    }
  };

  init();
};
